// src/i18n/en/satisfaction.ts
// «Satisfacción» — route /satisfaction, Dirección. See the es file.
export const satisfaction = {
  name: 'Satisfaction |||| Satisfaction',
  subtitle: 'The guest survey at the end',

  filters: {
    channel: 'Channel',
    allChannels: 'All channels',
  },

  channels: {
    assistant_phone: 'Assistant on the phone',
    assistant_kiosk: 'Assistant on the kiosk screen',
    kiosk_screen: 'Kiosk screen',
  },

  tiles: {
    overall: 'Average rating',
    ease: 'Average ease',
    responses: 'Responses',
    comments: 'Comments',
    scale: 'Scale of 1 to 5',
    responsesNote: 'Journeys with at least one question answered',
    insufficient: 'Insufficient sample: %{smart_count} response (minimum 20) |||| Insufficient sample: %{smart_count} responses (minimum 20)',
    commentsNote: 'Responses with a written comment',
  },

  answerCount: '%{smart_count} response |||| %{smart_count} responses',
  noAnswers: 'No responses',

  byChannel: {
    title: 'By channel',
    channel: 'Channel',
    responses: 'Responses',
    share: 'Share',
  },

  list: {
    title: 'Responses',
    onlyWithComment: 'Only with a comment',
    answeredAt: 'Date and time',
    channel: 'Channel',
    language: 'Language',
    overall: 'Rating',
    ease: 'Ease',
    comment: 'Comment',
    notAnswered: 'Not answered',
    noComment: 'No comment',
    timeZone: "Times in the property's time zone.",
    empty: 'No response matches these filters.',
    emptyWithComment: 'No guest has left a comment in this period.',
  },

  empty: {
    noFeed: 'This property does not send surveys yet.',
    noFeedHint: 'Responses will appear here as soon as guests answer the survey on the kiosk or in the assistant.',
    noResponses: 'There are no responses in this period yet.',
    noResponsesHint: 'Try a longer period or another channel.',
  },

  help: {
    title: 'Satisfaction',
    description:
      'At the end, the guest can rate the experience and how easy the process was from 1 to 5 and leave a comment. This page gathers those answers by property, period and channel.',
    features: {
      tiles: 'Every average comes with the number of responses behind it and is shown only with at least 20; below that, «Insufficient sample» appears with the number of responses. «Responses» counts journeys with at least one question answered; «By channel» counts each journey once, in the channel of its overall rating.',
      list: 'The list shows each response with its date, channel, language and comment; turn on «Only with a comment» to read only the comments.',
    },
    tips: {
      property: 'Change property at the top left; properties with check-in data or with surveys are listed. The default period is the last 30 days.',
    },
  },
};

export default satisfaction;
